export default __webpack_public_path__ + "static/media/81457.64355e85.svg";